import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { 
  FaSearch, FaFilter, FaLinkedin, FaEnvelope, FaGraduationCap, FaUserCircle, 
  FaBriefcase, FaMapMarkerAlt, FaProjectDiagram, FaTrophy, FaChartLine,
  FaGithub, FaTwitter, FaGlobe, FaCertificate, FaUsers, FaLightbulb,FaFacebook, FaInstagram
} from 'react-icons/fa';
import { Link } from 'react-router-dom';

// Enhanced sample data

const enhancedAlumniData = [
  {
    id: "1",
    fullName: "Aarav Patel",
    email: "aarav.patel@email.com",
    profileImage: "https://randomuser.me/api/portraits/men/1.jpg",
    graduationYear: 2018,
    major: "Computer Science and Engineering",
    university: "Indian Institute of Technology, Bombay",
    company: "Tata Consultancy Services",
    industry: "Information Technology",
    currentPosition: "Senior Software Engineer",
    location: "Mumbai, Maharashtra",
    skills: ["Java", "Spring Boot", "Microservices", "Docker", "Kubernetes"],
    achievements: "Led development of a core banking system used by 5 major Indian banks",
    bio: "Passionate about creating scalable software solutions and mentoring junior developers.",
    projects: ["Digital Payment Gateway", "Cloud Migration for Financial Services"],
    languages: ["English", "Hindi", "Gujarati"],
    interests: ["Artificial Intelligence", "Cricket", "Classical Music"],
    socialMedia: {
      linkedin: "linkedin.com/in/aaravpatel",
      github: "github.com/aaravp",
      twitter: "twitter.com/aaravtech"
    }
  },
  {
    id: "2",
    fullName: "Priya Sharma",
    email: "priya.sharma@email.com",
    profileImage: "https://randomuser.me/api/portraits/women/2.jpg",
    graduationYear: 2019,
    major: "Data Science",
    university: "Indian Statistical Institute, Kolkata",
    company: "Flipkart",
    industry: "E-commerce",
    currentPosition: "Data Scientist",
    location: "Bangalore, Karnataka",
    skills: ["Python", "Machine Learning", "SQL", "Tableau", "Big Data Analytics"],
    achievements: "Developed an AI model that improved product recommendations by 30%",
    bio: "Data enthusiast passionate about leveraging AI to solve real-world problems in e-commerce.",
    projects: ["Customer Segmentation Model", "Fraud Detection System"],
    languages: ["English", "Hindi", "Bengali"],
    interests: ["Data Visualization", "Badminton", "Travel Photography"],
    socialMedia: {
      linkedin: "linkedin.com/in/priyasharma",
      github: "github.com/priyads",
      twitter: "twitter.com/priyadata"
    }
  },
  {
    id: "3",
    fullName: "Arjun Reddy",
    email: "arjun.reddy@email.com",
    profileImage: "https://randomuser.me/api/portraits/men/3.jpg",
    graduationYear: 2020,
    major: "Mechanical Engineering",
    university: "National Institute of Technology, Tiruchirappalli",
    company: "Mahindra & Mahindra",
    industry: "Automotive",
    currentPosition: "Product Design Engineer",
    location: "Chennai, Tamil Nadu",
    skills: ["CAD", "Finite Element Analysis", "3D Printing", "Project Management", "Six Sigma"],
    achievements: "Key designer for Mahindra's award-winning electric SUV",
    bio: "Innovative engineer passionate about sustainable automotive design and electric vehicles.",
    projects: ["Lightweight Chassis Design", "Electric Vehicle Battery Cooling System"],
    languages: ["English", "Tamil", "Telugu"],
    interests: ["Electric Vehicles", "Robotics", "Classical Dance"],
    socialMedia: {
      linkedin: "linkedin.com/in/arjunreddy",
      github: "github.com/arjunr"
    }
  },
  {
    id: "4",
    fullName: "Zara Khan",
    email: "zara.khan@email.com",
    profileImage: "https://randomuser.me/api/portraits/women/4.jpg",
    graduationYear: 2017,
    major: "Electronics and Communication Engineering",
    university: "Birla Institute of Technology and Science, Pilani",
    company: "Reliance Jio",
    industry: "Telecommunications",
    currentPosition: "Network Engineer",
    location: "Gurgaon, Haryana",
    skills: ["5G Technology", "Network Security", "IoT", "CISCO Networking", "Cloud Computing"],
    achievements: "Led the team that implemented 5G in 3 major Indian cities",
    bio: "Tech enthusiast working on cutting-edge telecom solutions to connect India.",
    projects: ["5G Network Deployment", "IoT-based Smart City Solutions"],
    languages: ["English", "Hindi", "Urdu"],
    interests: ["Emerging Technologies", "Yoga", "Indian Classical Music"],
    socialMedia: {
      linkedin: "linkedin.com/in/zarakhan",
      twitter: "twitter.com/zaratech"
    }
  },
  {
    id: "5",
    fullName: "Vikram Malhotra",
    email: "vikram.malhotra@email.com",
    profileImage: "https://randomuser.me/api/portraits/men/5.jpg",
    graduationYear: 2016,
    major: "Business Administration",
    university: "Indian Institute of Management, Ahmedabad",
    company: "Paytm",
    industry: "Fintech",
    currentPosition: "Product Manager",
    location: "Noida, Uttar Pradesh",
    skills: ["Product Strategy", "Agile Methodologies", "Data Analytics", "UX Design", "Digital Payments"],
    achievements: "Launched a new credit product that acquired 1 million users in 3 months",
    bio: "Passionate about revolutionizing financial services through technology in India.",
    projects: ["UPI 2.0 Integration", "AI-powered Credit Scoring System"],
    languages: ["English", "Hindi", "Punjabi"],
    interests: ["Fintech Innovations", "Stand-up Comedy", "Marathon Running"],
    socialMedia: {
      linkedin: "linkedin.com/in/vikrammalhotra",
      twitter: "twitter.com/vikramproduct"
    }
  },
  {
    id: "6",
    fullName: "Anjali Mehta",
    email: "anjali.mehta@email.com",
    profileImage: "https://randomuser.me/api/portraits/women/6.jpg",
    graduationYear: 2021,
    major: "Chemical Engineering",
    university: "Indian Institute of Technology, Delhi",
    company: "Shell",
    industry: "Energy",
    currentPosition: "Process Engineer",
    location: "New Delhi, Delhi",
    skills: ["Process Optimization", "Catalysis", "Simulation Software", "HSE Management", "Six Sigma"],
    achievements: "Optimized refinery process, reducing waste by 15%",
    bio: "Chemical engineer focused on sustainable energy solutions and green technologies.",
    projects: ["Green Hydrogen Production", "Sustainable Refining Techniques"],
    languages: ["English", "Hindi"],
    interests: ["Renewable Energy", "Sustainable Living", "Yoga"],
    socialMedia: {
      linkedin: "linkedin.com/in/anjalimehta"
    }
  },
  {
    id: "7",
    fullName: "Rohan Verma",
    email: "rohan.verma@email.com",
    profileImage: "https://randomuser.me/api/portraits/men/7.jpg",
    graduationYear: 2015,
    major: "Finance",
    university: "Faculty of Management Studies, Delhi University",
    company: "Goldman Sachs",
    industry: "Finance",
    currentPosition: "Investment Analyst",
    location: "Mumbai, Maharashtra",
    skills: ["Financial Modeling", "Equity Research", "Portfolio Management", "Risk Analysis", "Excel"],
    achievements: "Generated over $2 million in profits for high-net-worth clients",
    bio: "Finance professional with a knack for market analysis and investment strategy.",
    projects: ["Emerging Markets Investment Strategy", "AI-driven Stock Analysis Tool"],
    languages: ["English", "Hindi"],
    interests: ["Stock Market", "Chess", "Public Speaking"],
    socialMedia: {
      linkedin: "linkedin.com/in/rohanverma"
    }
  },
  {
    id: "8",
    fullName: "Meera Iyer",
    email: "meera.iyer@email.com",
    profileImage: "https://randomuser.me/api/portraits/women/8.jpg",
    graduationYear: 2014,
    major: "Architecture",
    university: "School of Planning and Architecture, Delhi",
    company: "L&T Realty",
    industry: "Architecture and Design",
    currentPosition: "Senior Architect",
    location: "Bangalore, Karnataka",
    skills: ["Urban Design", "Sustainable Architecture", "AutoCAD", "Revit", "Project Management"],
    achievements: "Designed an award-winning eco-friendly residential complex",
    bio: "Architect committed to sustainable and innovative urban design solutions.",
    projects: ["Smart City Planning", "Eco-friendly Residential Complex"],
    languages: ["English", "Kannada", "Hindi"],
    interests: ["Green Architecture", "Travel", "Classical Dance"],
    socialMedia: {
      linkedin: "linkedin.com/in/meeraiyer"
    }
  },
  {
    id: "9",
    fullName: "Rahul Desai",
    email: "rahul.desai@email.com",
    profileImage: "https://randomuser.me/api/portraits/men/9.jpg",
    graduationYear: 2013,
    major: "Biomedical Engineering",
    university: "All India Institute of Medical Sciences, Delhi",
    company: "Medtronic",
    industry: "Medical Devices",
     currentPosition: "Senior Architect",
    location: "Bangalore, Karnataka",
    skills: ["Urban Design", "Sustainable Architecture", "AutoCAD", "Revit", "Project Management"],
    achievements: "Designed an award-winning eco-friendly residential complex",
    bio: "Architect committed to sustainable and innovative urban design solutions.",
    projects: ["Smart City Planning", "Eco-friendly Residential Complex"],
    languages: ["English", "Kannada", "Hindi"],
    interests: ["Green Architecture", "Travel", "Classical Dance"],
    socialMedia: {
      linkedin: "linkedin.com/in/meeraiyer"
    }
  },
  {
    id: "10",
    fullName: "Neha Kapoor",
    email: "neha.kapoor@email.com",
    profileImage: "https://randomuser.me/api/portraits/women/10.jpg",
    graduationYear: 2012,
    major: "Marketing",
    university: "Indian School of Business, Hyderabad",
    company: "Hindustan Unilever",
    industry: "FMCG",
    currentPosition: "Brand Manager",
    location: "Mumbai, Maharashtra",
    skills: ["Brand Strategy", "Market Research", "Digital Marketing", "Content Development", "SEO"],
    achievements: "Led a marketing campaign that increased product sales by 40% in 6 months",
    bio: "Creative marketing professional with a passion for brand storytelling and consumer engagement.",
    projects: ["Digital Marketing Campaign for FMCG Product", "Brand Repositioning Strategy"],
    languages: ["English", "Hindi"],
    interests: ["Creative Writing", "Photography", "Cooking"],
    socialMedia: {
      linkedin: "linkedin.com/in/nehakapoor",
      twitter: "twitter.com/nehamarkets"
    }
  }
];

const AlumniDirectoryPage = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filterOpen, setFilterOpen] = useState(false);
  const [filteredAlumni, setFilteredAlumni] = useState(enhancedAlumniData);
  const [filters, setFilters] = useState({
    graduationYear: 'All Years',
    major: 'All Majors',
    industry: 'All Industries',
    skills: 'All Skills'
  });

  useEffect(() => {
    filterAlumni();
  }, [searchTerm, filters]);

  const filterAlumni = () => {
    let filtered = enhancedAlumniData.filter(alumni => {
      const matchesSearch = alumni.fullName.toLowerCase().includes(searchTerm.toLowerCase()) ||
                            (alumni.company && alumni.company.toLowerCase().includes(searchTerm.toLowerCase())) ||
                            (alumni.currentPosition && alumni.currentPosition.toLowerCase().includes(searchTerm.toLowerCase()));
      const matchesYear = filters.graduationYear === 'All Years' || alumni.graduationYear.toString() === filters.graduationYear;
      const matchesMajor = filters.major === 'All Majors' || alumni.major === filters.major;
      const matchesIndustry = filters.industry === 'All Industries' || alumni.industry === filters.industry;
      const matchesSkills = filters.skills === 'All Skills' || alumni.skills.includes(filters.skills);

      return matchesSearch && matchesYear && matchesMajor && matchesIndustry && matchesSkills;
    });

    setFilteredAlumni(filtered);
  };
  
  const handleFilterChange = (event) => {
    const { name, value } = event.target;
    setFilters(prevFilters => ({
      ...prevFilters,
      [name]: value
    }));
  };


  
  const AlumniCard = ({ alumni }) => {
    const [score, setScore] = useState(0);
    const targetScore = Math.floor(Math.random() * 41) + 60; // Random score between 60 and 100
  
    useEffect(() => {
      const timer = setInterval(() => {
        setScore(prevScore => {
          if (prevScore < targetScore) {
            return prevScore + 1;
          }
          clearInterval(timer);
          return prevScore;
        });
      }, 20);
  
      return () => clearInterval(timer);
    }, [targetScore]);
  
    return (
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
        className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition duration-300"
      >
        <div className="p-6">
          <div className="flex items-center mb-4">
            <div className="relative">
              <img 
                src={alumni.profileImage} 
                alt={alumni.fullName} 
                className="w-24 h-24 rounded-full object-cover border-4 border-blue-100"
              />
             
            </div>
           
            <div className="ml-4">
              <h2 className="text-xl font-bold text-gray-800">{alumni.fullName}</h2>
              <p className="text-sm text-gray-600">{alumni.currentPosition}</p>
              <p className="text-sm text-gray-500">{alumni.company}</p>
            </div>
            <motion.div 
                className="absolute -mt-20 ml-64 bg-blue-500 text-white px-2 py-1 rounded-full text-xs font-semibold"
                initial={{ scale: 0.8, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{ delay: 0.5, duration: 0.3 }}
              >
                {score}% Match
              </motion.div>
          </div>
         
          <div className="mb-4">
            <div className="flex items-center text-sm text-gray-600 mb-1">
              <FaMapMarkerAlt className="mr-2 text-gray-400" />
              {alumni.location}
            </div>
            <div className="flex items-center text-sm text-gray-600 mb-1">
              <FaGraduationCap className="mr-2 text-gray-400" />
              {alumni.major}, Class of {alumni.graduationYear}
            </div>
            <div className="flex items-center text-sm text-gray-600">
              <FaBriefcase className="mr-2 text-gray-400" />
              {alumni.industry}
            </div>
          </div>
          
          <div className="mb-4">
            <h3 className="text-sm font-semibold text-gray-700 mb-2">Skills</h3>
            <div className="flex flex-wrap gap-2">
              {alumni.skills.slice(0, 4).map((skill, index) => (
                <span key={index} className="bg-blue-50 text-blue-700 text-xs font-medium px-2.5 py-0.5 rounded">
                  {skill}
                </span>
              ))}
              {alumni.skills.length > 4 && (
                <span className="bg-gray-100 text-gray-800 text-xs font-medium px-2.5 py-0.5 rounded">
                  +{alumni.skills.length - 4} more
                </span>
              )}
            </div>
          </div>
          
          <div className="text-sm text-gray-600 mb-4">
            <h3 className="font-semibold text-gray-700 mb-1">Recent Achievement</h3>
            <p>{alumni.achievements}</p>
          </div>
        </div>
        
        <div className="px-4 py-2 bg-gray-50 border-t flex justify-between items-center">
            <div className="flex space-x-2">
              {alumni.socialMedia.linkedin && (
                <a href={alumni.socialMedia.linkedin} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800">
                  <FaLinkedin />
                </a>
              )}
              {alumni.socialMedia.github && (
                <a href={alumni.socialMedia.github} target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-gray-800">
                  <FaGithub />
                </a>
              )}
              {alumni.socialMedia.twitter && (
                <a href={alumni.socialMedia.twitter} target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:text-blue-600">
                  <FaTwitter />
                </a>
              )}
            </div>
          
          
          <Link to={`/alumni/${alumni.id}`} className="text-blue-600 hover:text-blue-800 font-semibold text-sm">
            Connect
          </Link>
        </div>
      </motion.div>
    );
  };
  

  return (
    <div className="bg-gray-100 min-h-screen">
      <header className="bg-gradient-to-r from-blue-600 to-indigo-800 text-white py-16">
        <div className="container mx-auto px-4">
          <h1 className="text-5xl font-bold mb-4">Alumni Directory</h1>
          <p className="text-xl max-w-2xl">Connect with fellow alumni, expand your professional network, and discover exciting opportunities within our vibrant community.</p>
        </div>
      </header>

      <main className="container mx-auto px-4 py-12">
        <div className="mb-12 flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="relative w-full md:w-2/3">
            <input
              type="text"
              placeholder="Search alumni by name, company, or position..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full pl-12 pr-4 py-3 rounded-full border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 shadow-sm text-lg"
            />
            <FaSearch className="absolute left-4 top-4 text-gray-400 text-xl" />
          </div>
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => setFilterOpen(!filterOpen)}
            className="bg-blue-500 text-white px-6 py-3 rounded-full flex items-center hover:bg-blue-600 transition duration-300 shadow-md text-lg font-semibold"
          >
            <FaFilter className="mr-2" />
            Filter
          </motion.button>
        </div>

        <AnimatePresence>
          {filterOpen && (
            <motion.div
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: 'auto', opacity: 1 }}
              exit={{ height: 0, opacity: 0 }}
              transition={{ duration: 0.3 }}
              className="mb-12 p-8 bg-white rounded-xl shadow-lg"
            >
              <h2 className="text-2xl font-semibold mb-6">Filter Options</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Graduation Year</label>
                  <select
                    name="graduationYear"
                    value={filters.graduationYear}
                    onChange={handleFilterChange}
                    className="w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 rounded-md shadow-sm"
                  >
                    <option>All Years</option>
                    {[2022, 2021, 2020, 2019, 2018, 2017, 2016].map(year => (
                      <option key={year}>{year}</option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Major</label>
                  <select
                    name="major"
                    value={filters.major}
                    onChange={handleFilterChange}
                    className="w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 rounded-md shadow-sm"
                  >
                    <option>All Majors</option>
                    {['Computer Science', 'Data Science', 'Business Administration', 'Electrical Engineering', 'Marketing', 'Mechanical Engineering', 'Graphic Design', 'Finance', 'Environmental Science'].map(major => (
                      <option key={major}>{major}</option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Industry</label>
                  <select
                    name="industry"
                    value={filters.industry}
                    onChange={handleFilterChange}
                    className="w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 rounded-md shadow-sm"
                  >
                    <option>All Industries</option>
                    {['Technology', 'Data Analytics', 'Consulting', 'Digital Marketing', 'Automotive', 'Design', 'Finance', 'Environmental Services'].map(industry => (
                      <option key={industry}>{industry}</option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Skills</label>
                  <select
                    name="skills"
                    value={filters.skills}
                    onChange={handleFilterChange}
                    className="w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 rounded-md shadow-sm"
                  >
                    <option>All Skills</option>
                    {['JavaScript', 'Python', 'React', 'Machine Learning', 'Data Analysis', 'Project Management', 'UI/UX Design', 'Financial Modeling', 'Sustainability'].map(skill => (
                      <option key={skill}>{skill}</option>
                    ))}
                  </select>
                </div>
              </div>
            </motion.div>
          )}
        </AnimatePresence>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredAlumni.map((alumni) => (
            <AlumniCard key={alumni.id} alumni={alumni} />
          ))}
        </div>

        {filteredAlumni.length === 0 && (
          <motion.div 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
            className="text-center py-16"
          >
            <FaSearch className="text-6xl text-gray-400 mx-auto mb-6" />
            <h2 className="text-3xl font-semibold text-gray-700 mb-4">No Results Found</h2>
            <p className="text-xl text-gray-500 mb-8">Try adjusting your search or filter criteria</p>
            <button
              onClick={() => {
                setSearchTerm('');
                setFilters({
                  graduationYear: 'All Years',
                  major: 'All Majors',
                  industry: 'All Industries',
                  skills: 'All Skills'
                });
              }}
              className="bg-blue-500 text-white px-6 py-3 rounded-full hover:bg-blue-600 transition duration-300 shadow-md text-lg font-semibold"
            >
              Reset Filters
            </button>
          </motion.div>
        )}
      </main>

     
    </div>
  );
};

export default AlumniDirectoryPage;